var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack228({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.55,12.52V3.93H8.2a6.43,6.43,0,0,1,2,.23,2,2,0,0,1,1,.83,2.44,2.44,0,0,1,.37,1.35A2.31,2.31,0,0,1,11,7.94a2.72,2.72,0,0,1-1.7.79,3.94,3.94,0,0,1,.93.72,8.94,8.94,0,0,1,1,1.4l1,1.67H10.19L8.94,10.65A11.34,11.34,0,0,0,8,9.39,1.47,1.47,0,0,0,7.5,9a3,3,0,0,0-.87-.09H6.28v3.58Zm1.73-5H7.56a6.7,6.7,0,0,0,1.56-.1,1,1,0,0,0,.49-.36,1.13,1.13,0,0,0,.17-.65,1,1,0,0,0-.23-.7,1.05,1.05,0,0,0-.65-.34c-.14,0-.56,0-1.27,0H6.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack228);
export default __webpack_public_path__ + "static/media/Symbolpack_2_28.7985536999c80cf36b755bb5afcca13d.svg";
export { ForwardRef as ReactComponent };